import React from "react";
import {
    AutocompleteInput, BooleanInput,
    Create,
    CreateProps,
    required,
    SimpleForm,
    TextInput,
} from "react-admin";
import { useCountries } from "api/enums";
import { useTranslation } from "react-i18next";

export const OrganizationCreate = (props: CreateProps) => {
    const { t } = useTranslation();
    const countryResult = useCountries();

    return (
        <Create {...props}>
            <SimpleForm>
                <TextInput source="name" validate={[required()]} />
                <BooleanInput source="isActive" />
                <TextInput label={t("address.street")} source="address.street" />
                <TextInput label={t("address.addressLine2")} source="address.addressLine2" />
                <TextInput label={t("address.city")} source="address.city" />
                <TextInput label={t("address.state")} source="address.state" />
                <TextInput label={t("address.zipCode")} source="address.zipCode" />
                <AutocompleteInput
                    label={t("address.country")}
                    source="address.countryId"
                    choices={(countryResult.data || []).map((item) => ({
                        id: item.id,
                        name: item.name,
                    }))}
                    validate={[required()]}
                />
            </SimpleForm>
        </Create>
    );
}